(function () {
  'use strict';

  function initSlider(root) {
    var track = root.querySelector('[data-image-slider-track]');
    var slides = root.querySelectorAll('[data-image-slider-slide]');
    var prevBtn = root.querySelector('[data-image-slider-prev]');
    var nextBtn = root.querySelector('[data-image-slider-next]');
    var dots = root.querySelectorAll('[data-image-slider-dot]');

    if (!track || slides.length < 2) return; // nothing to slide between

    var transitionType = root.getAttribute('data-transition') || 'slide';
    var loop = root.getAttribute('data-loop') === 'true';
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseFloat(root.getAttribute('data-autoplay-speed')) || 5;

    var currentIndex = 0;
    var slideCount = slides.length;
    var autoplayTimer = null;

    function goTo(index) {
      if (loop) {
        index = (index + slideCount) % slideCount;
      } else {
        index = Math.max(0, Math.min(index, slideCount - 1));
      }

      if (transitionType === 'fade') {
        slides.forEach(function (slide, i) {
          var isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          var link = slide.querySelector('[tabindex]');
          if (link) link.setAttribute('tabindex', isActive ? '0' : '-1');
        });
      } else {
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        slides.forEach(function (slide, i) {
          var isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          var link = slide.querySelector('[tabindex]');
          if (link) link.setAttribute('tabindex', isActive ? '0' : '-1');
        });
      }

      dots.forEach(function (dot, i) {
        var isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      if (!loop) {
        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index === slideCount - 1;
      }

      currentIndex = index;
    }

    function next() {
      goTo(currentIndex + 1);
    }

    function prev() {
      goTo(currentIndex - 1);
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(next, autoplaySpeed * 1000);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay(); // reset the timer after a manual interaction
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
        startAutoplay();
      });
    });

    goTo(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-image-slider]').forEach(initSlider);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-image-slider]');
    if (section) initSlider(section);
  });
})();